import { SVGIconComponent } from './types';

export const Kiosk: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 34"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_kiosk">
      <path
        id="Combined-Shape"
        fill="currentColor"
        d="M12.2,16.4c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1l0,0v4.9c0.3-0.4,0.7-0.7,1.3-0.7
		c0.8,0,1.5,0.7,1.5,1.5l0,0v0c0.3-0.4,0.7-0.7,1.3-0.7c0.8,0,1.5,0.7,1.5,1.5l0,0v0c0.3-0.4,0.7-0.7,1.3-0.7c0.8,0,1.5,0.6,1.5,1.4
		l0,0l0,4c0,1.3-0.5,2.5-1.5,3.4C19.6,33.5,18.4,34,17,34l0,0h-2.3c-1.7,0-3.3-0.7-4.4-2l0,0l-3.8-4.4c-0.3-0.3-0.4-0.7-0.3-1.2
		c0.1-0.4,0.3-0.8,0.6-1c0.6-0.4,1.4-0.3,1.9,0.2l0,0l1.5,1.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2l0,0v-9
		C10.7,17.1,11.3,16.4,12.2,16.4z M19.6,2c0.4,0,0.7,0.3,0.7,0.7l0,0v20.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2-0.2-0.4-0.4-0.7-0.6l0,0V3.3
		H5.4v19h4.2v1.3H4.7C4.3,23.7,4,23.4,4,23l0,0V2.7C4,2.3,4.3,2,4.7,2l0,0H19.6z M12.1,12.8c2.9,0,5.2,2.3,5.2,5.1
		c0,0.7-0.1,1.3-0.4,1.9c-0.1,0.2-0.2,0.3-0.4,0.3c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.3-0.3-0.6c0.2-0.5,0.3-1.1,0.3-1.6
		c0-2.3-1.9-4.2-4.3-4.2s-4.3,1.9-4.3,4.2c0,0.6,0.1,1.1,0.3,1.6c0.1,0.2,0,0.5-0.2,0.6c-0.2,0.1-0.5,0-0.6-0.2
		c-0.2-0.6-0.4-1.2-0.4-1.9C6.9,15,9.3,12.8,12.1,12.8z M12.2,14.6c1.9,0,3.4,1.5,3.4,3.3c0,0.3-0.1,0.6-0.1,0.9
		C15.4,18.9,15.2,19,15,19c-0.1,0-0.1,0-0.1,0c-0.2-0.1-0.4-0.3-0.2-0.6c0.1-0.2,0.1-0.4,0.1-0.6c0-1.3-1.1-2.4-2.5-2.4
		c-1.4,0-2.5,1.1-2.5,2.4c0,0.2,0,0.4,0.1,0.6c0.1,0.2-0.1,0.5-0.3,0.6c-0.2,0.1-0.5-0.1-0.6-0.3c-0.1-0.3-0.1-0.6-0.1-0.9
		C8.8,16,10.3,14.6,12.2,14.6z"
      />
    </g>
  </svg>
);
